var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"notification is-warning"},[_vm._v(_vm._s(_vm.$t('empty')))]),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }